import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import Check from "../components/Check";
import ButtonLayout from "../components/ButtonLayout";

export default function (props) {
  return (
    <BackgroundUser>
      <Logo></Logo>
      <View>
        {props.route.params.success && (
          <Title>¡Su cita ha sido completada con éxito!</Title>
        )}
        {!props.route.params.success && (
          <Title>Ha ocurrido un error al reservar su cita</Title>
        )}

        <Check success={props.route.params.success}></Check>
      </View>
      <ButtonLayout
        onPress={() => props.navigation.navigate("UserScreen")}
        text={"Volver al menú"}></ButtonLayout>
    </BackgroundUser>
  );
}
